import {
	financePayoutFlags,
	updateFinancePayoutsEnabled,
	updateFinanceVerticalPayout,
	updateFinancePayoutAllowlist,
} from '@/services/finance.service'

export default {
	namespaced: true,
	state: {
		flags: { enabled: false, verticals: [], allowlist_user_ids: [] },
		flagsStatus: 'init',
		flagsActionStatus: 'init',
	},
	getters: {
		getFlags: (state) => state.flags,
		getFlagsStatus: (state) => state.flagsStatus,
		getFlagsActionStatus: (state) => state.flagsActionStatus,
	},
	mutations: {
		SET_FLAGS(state, val) {
			state.flags = val
		},
		SET_FLAGS_STATUS(state, val) {
			state.flagsStatus = val
		},
		SET_FLAGS_ACTION_STATUS(state, val) {
			state.flagsActionStatus = val
		},
	},
	actions: {
		async fetchFlags({ commit }) {
			commit('SET_FLAGS_STATUS', 'pending')
			try {
				const { data } = await financePayoutFlags()
				commit('SET_FLAGS', data)
				commit('SET_FLAGS_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_FLAGS_STATUS', 'init')
				throw error
			}
		},
		async toggleEnabled({ commit }, enabled) {
			commit('SET_FLAGS_ACTION_STATUS', 'pending')
			try {
				const { data } = await updateFinancePayoutsEnabled(enabled)
				commit('SET_FLAGS', data)
				commit('SET_FLAGS_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_FLAGS_ACTION_STATUS', 'init')
				throw error
			}
		},
		async toggleVertical({ commit }, { vertical, payout }) {
			commit('SET_FLAGS_ACTION_STATUS', 'pending')
			try {
				const { data } = await updateFinanceVerticalPayout(vertical, payout)
				commit('SET_FLAGS', data)
				commit('SET_FLAGS_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_FLAGS_ACTION_STATUS', 'init')
				throw error
			}
		},
		async updateAllowlist({ commit }, userIds) {
			commit('SET_FLAGS_ACTION_STATUS', 'pending')
			try {
				const { data } = await updateFinancePayoutAllowlist(userIds)
				commit('SET_FLAGS', data)
				commit('SET_FLAGS_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_FLAGS_ACTION_STATUS', 'init')
				throw error
			}
		},
	},
}
